export const calculateAge = (dob) => {
  dob = dob || '1970-01-01'; // if dob === null for legacy users. Default to over 16

  const [year, month, day] = dob.split('-');

  const selectedDate = new Date(month + '/' + day + '/' + year);

  const today = new Date();

  const ageDiffMs = today - selectedDate;

  const ageDate = new Date(ageDiffMs);

  return Math.abs(ageDate.getUTCFullYear() - 1970);
};
